export default __webpack_public_path__ + "static/media/ng_phone2.b0392d75.png";